<script>
export default {
  name: "advertisementTwo",
  props: {
    propsImage: String,
    propsClick: String
  }
};
</script>

<template>
  <el-row style="background-color: #ffffff">
    <el-col :span="24" style="display: flex; justify-content: center">
      <img :src="propsImage" class="image-ad" loading="lazy" />
    </el-col>
  </el-row>
</template>

<style scoped>
.image-ad {
  width: 80%;
  height: 205px;
}

@media only screen and (max-width: 375px) {
  .image-ad {
    width: 90%;
    height: 105px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1300px) {
  .image-ad {
    width: 85%;
    height: 100%;
  }
}

@media only screen and (min-width: 1301px) {
  .image-ad {
    width: 75%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/advertisementTwo.vue